export default __webpack_public_path__ + "static/media/saude.da86ec12.png";